import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/styles.css.ts", "@paypalcorp/pp-react-loading-spinner");
import { style, keyframes } from '@vanilla-extract/css';
import { utilStyles } from '@paypalcorp/pp-react-utils';
import { tokens } from '@paypalcorp/pp-react-theme';
const {
  ppuiEaseLoopStandard
} = utilStyles.variables;
const borderSpinner = keyframes({
  'to': {
    transform: `rotate(360deg)`
  }
}, 'border_spinner');
const xSSize = '1rem';
export const base = style({
  color: tokens.color.primary.main,
  animation: `${borderSpinner} ${tokens.motion.duration.loop.standard} ${ppuiEaseLoopStandard} infinite`,
  border: `${tokens.border.thickness.emphasis} solid currentColor`,
  borderRadius: '50%',
  clipPath: 'polygon(50% 0%, 50% 50%, 100% 50%, 100% 100%, 0 100%, 0 0)'
}, 'loading_spinner_base');

// Size Xs
export const sizeXs = style({
  minWidth: xSSize,
  minHeight: xSSize
}, 'loading_spinner_size_xs');

// Size Sm
export const sizeSm = style({
  width: tokens.size.circle.xs,
  height: tokens.size.circle.xs
}, 'loading_spinner_size_sm');

// Size md
export const sizeMd = style({
  width: tokens.size.circle.sm,
  height: tokens.size.circle.sm
}, 'loading_spinner_size_md');

// Size Lg
export const sizeLg = style({
  width: tokens.size.circle.md,
  height: tokens.size.circle.md
}, 'loading_spinner_size_lg');

// Size Xl
export const sizeXl = style({
  width: tokens.size.circle.xl,
  height: tokens.size.circle.xl
}, 'loading_spinner_size_xl');

//  Inverse
export const inverse = style({
  color: tokens.color.primary.contrast
}, 'loading_spinner_inverse');
__vanilla_filescope__.endFileScope();
